<template>
  <div class="form-group">
    <label
      :for="`input-shopper-custprop-${Guid}-${_uid}`"
      class="col-md-3 control-label"
      :class="{ 'text-red': Recommended && !value }"
    >
      {{ Title }}
      <span v-if="Recommended">*</span>
    </label>
    <div class="col-md-9">
      <input
        type="text"
        class="form-control"
        :id="`input-shopper-custprop-${Guid}-${_uid}`"
        :value="value"
        @change="updateValue"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "TextInput",
  props: {
    Title: String,
    Guid: String,
    Recommended: { type: Boolean, default: false },
    value: { type: String, default: "" },
    index: { type: Number, default: -1 },
  },
  methods: {
    updateValue(event) {
      this.$emit("input", event.target.value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// TextInput.vue?419938f0